import React, { Component } from 'react'
import EditButtonSectionModal from "../../editbutton.component.jsx"
import { FormattedDate, FormattedMessage, injectIntl, defineMessages, FormattedNumber } from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import Icon from "../../../../common/icon/icon.component.jsx";
import InvoiceStatusBadge from "../../../../invoice/status.component.jsx";

const messages = defineMessages({
    "dueDate": {
        id: 'proposal.customer_account_statement.due_date',
        defaultMessage: 'Due date',
    },
    "fullyPaidAt": {
        id: 'proposal.customer_account_statement.fully_paid_date',
        defaultMessage: 'Fully paid date',
    },
    "createdAt": {
        id: 'proposal.customer_account_statement.created_date',
        defaultMessage: 'Created date',
    },
    "sentAt": {
        id: 'proposal.customer_account_statement.sent_date',
        defaultMessage: 'Sent date',
    },
    "uniqueExternalId": {
        id: 'proposal.customer_account_statement.external_id',
        defaultMessage: 'External ID',
    },
    "lightspeedWorkorderId": {
        id: 'proposal.customer_account_statement.workorder_id',
        defaultMessage: 'Workorder ID',
    },
})

class OrderStatusContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
        this.showEdition = this.showEdition.bind(this)
        this.hideEdition = this.hideEdition.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
        })
    }

    showEdition() {
        if (this.state.editable) {
            this.setState({
                edition: true,
            })
        }
    }

    hideEdition() {
        if (this.state.editable) {
            this.setState({
                edition: false,
            })
        }
    }


    render() {
        if (!this.state.section || !this.state.variables.quote) {
            return <div />
        }

        let allowedStatuses = this.state.section.attributes.content.displayedStatuses
        if (allowedStatuses.length === 0) {
            allowedStatuses = this.state.variables.quote.orderStatuses.filter(s => s.attributes.type === 'ordered').map(s => s.id)
        }

        const statusDetails = {}
        for (let i in this.state.variables.quote.orderStatuses) {
            const status = this.state.variables.quote.orderStatuses[i]
            statusDetails[status.id] = {
                name: status.attributes.name,
                type: status.attributes.type,
            }
        }

        const steps = []
        let firstStep = {
            done: false
        }
        let lastStep = {
            done: false
        }
        for (let i in this.state.variables.quote.customStatusDates) {
            const date = this.state.variables.quote.customStatusDates[i]
            const status = statusDetails[date.attributes.customStatusId] || {}
            if (status.type === 'ordered' && allowedStatuses.includes(date.attributes.customStatusId)) {
                steps.push({
                    date: date.attributes.changedAt,
                    name: status.name,
                    done: true,
                })
            }
            if (status.type === 'completed' && !lastStep.done) {
                lastStep = {
                    date: date.attributes.changedAt,
                    name: status.name,
                    done: true,
                }
            }
        }
        if (steps.length < allowedStatuses.length) {
            const missingSteps = allowedStatuses.length - steps.length
            for (let i = 0; i < missingSteps; i++) {
                steps.push({
                    done: false,
                })
            }
        }
        if (this.state.variables.quote.orderedAt) {
            firstStep = {
                date: this.state.variables.quote.orderedAt,
                name: <FormattedMessage
                    id="order_status.ordered_label"
                    defaultMessage="Ordered"
                />,
                done: true,
            }
        }

        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className={'d-sm-none w-100'}>
                    <div className={'col-12 py-2'}>
                        <div className={'d-flex w-100'}>
                            <div className={'pl-2'}>
                                <div className={'w-100 d-flex justify-content-center '}>
                                    <Icon className={"px-2 order-status-icon " + (firstStep.done ? '' : 'disabled')} value={firstStep.done ? 'check-circle' : 'circle'} />
                                </div>
                                <div className={'w-100 d-flex justify-content-center '}>
                                    <div className={"order-status-h-line " + (firstStep.done || lastStep.done ? '' : 'disabled')}>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            <div className={'w-75 pl-3'}>
                                <p className={'mb-0 text-secondary'}>{firstStep.name}</p>
                                <p className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(firstStep.date)} />
                                    </small>
                                </p>
                            </div>
                        </div>

                        {steps.map(s => {
                            return <div className={'d-flex w-100'}>
                                <div className={'pl-2'}>
                                    <div className={'w-100 d-flex justify-content-center '}>
                                        <div className={"order-status-h-line " + (s.done || lastStep.done ? '' : 'disabled')}>
                                            <br />
                                        </div>
                                    </div>
                                    <div className={'w-100 d-flex justify-content-center '}>
                                        <Icon className={"px-2 order-status-icon " + (s.done || lastStep.done ? '' : 'disabled')} value={s.done ? 'check-circle' : 'circle'} />
                                    </div>
                                    <div className={'w-100 d-flex justify-content-center '}>
                                        <div className={"order-status-h-line " + (s.done || lastStep.done ? '' : 'disabled')}>
                                            <br />
                                        </div>
                                    </div>
                                </div>
                                <div className={'w-75 pl-3 d-flex align-items-center'}>
                                    <div className={'w-100'}>
                                        <p className={'mb-0 text-secondary'}>{s.name}</p>
                                        {s.date && <p className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedDate
                                                    year='numeric'
                                                    month='long'
                                                    day='numeric'
                                                    value={new Date(s.date)} />
                                            </small>
                                        </p>}
                                    </div>

                                </div>
                            </div>
                        })}
                        <div className={'d-flex w-100'}>
                            <div className={'pl-2'}>
                                <div className={'w-100 d-flex justify-content-center '}>
                                    <div className={"order-status-h-line " + (lastStep.done ? '' : 'disabled')}>
                                        <br />
                                    </div>
                                </div>
                                <div className={'w-100 d-flex justify-content-center '}>
                                    <Icon className={"px-2 order-status-icon " + (lastStep.done ? '' : 'disabled')} value={lastStep.done ? 'check-circle' : 'circle'} />
                                </div>
                            </div>
                            <div className={'w-75 pl-3'}>
                                <p className={'mb-0 text-secondary'}>{lastStep.name}</p>
                                {lastStep.date && <p className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(lastStep.date)} />
                                    </small>
                                </p>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'d-none d-sm-block w-100'}>
                    <div className={'col-12 d-flex py-2'}>
                        <div >
                            <div className={'w-100 d-flex align-items-center pl-2'}>
                                <Icon className={"px-2 order-status-icon " + (firstStep.done ? '' : 'disabled')} value={firstStep.done ? 'check-circle' : 'circle'} />
                                <div className={"flex-fill"}><hr className={"order-status-line " + (firstStep.done || lastStep.done ? '' : 'disabled')} /></div>
                            </div>
                            <div className={'w-100 pl-3'}>
                                <p className={'mb-0 text-secondary'}>{firstStep.name}</p>
                                <p className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(firstStep.date)} />
                                    </small>
                                </p>
                            </div>
                        </div>
                        {steps.map(s => {
                            return <div className={'flex-fill'}>
                                <div className={'w-100 flex-fill d-flex align-items-center'}>
                                    <div className={"flex-fill"}><hr className={"order-status-line " + (s.done || lastStep.done ? '' : 'disabled')} /></div>
                                    <Icon className={"px-2 order-status-icon " + (s.done || lastStep.done ? '' : 'disabled')} value={s.done ? 'check-circle' : 'circle'} />
                                    <div className={"flex-fill"}><hr className={"order-status-line " + (s.done || lastStep.done ? '' : 'disabled')} /></div>
                                </div>
                                <div className={'w-100 text-center'}>
                                    <p className={'mb-0 text-secondary'}>{s.name}</p>
                                    {s.date && <p className={'mb-0 text-secondary'}>
                                        <small>
                                            <FormattedDate
                                                year='numeric'
                                                month='long'
                                                day='numeric'
                                                value={new Date(s.date)} />
                                        </small>
                                    </p>}
                                </div>
                            </div>
                        })}
                        <div className={'flex-fill'}>
                            <div className={'w-100 flex-fill d-flex align-items-center pr-2'}>
                                <div className={"flex-fill"}><hr className={"order-status-line " + (lastStep.done ? '' : 'disabled')} /></div>
                                <Icon className={"px-2 order-status-icon " + (lastStep.done ? '' : 'disabled')} value={lastStep.done ? 'check-circle' : 'circle'} />
                            </div>
                            <div className={'w-100 pr-3 text-right'}>
                                <p className={'mb-0 text-secondary'}>{lastStep.name}</p>
                                {lastStep.date && <p className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(lastStep.date)} />
                                    </small>
                                </p>}
                            </div>
                        </div>
                    </div>
                </div>
            </SectionWrapper>
        );
    }
}

export default injectIntl(OrderStatusContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/order-status/section.component.jsx